// Keep in sync with app/enums/webhookEvents
export const webhookEvents = {
  VIDEO_TR_ACCEPTED: 'video.transformation.accepted',
  VIDEO_TR_READY: 'video.transformation.ready',
  VIDEO_TR_ERROR: 'video.transformation.error',
  UPLOAD_PRE_TR_SUCCESS: 'upload.pre-transform.success',
  UPLOAD_PRE_TR_ERROR: 'upload.pre-transform.error',
  UPLOAD_POST_TR_SUCCESS: 'upload.post-transform.success',
  UPLOAD_POST_TR_ERROR: 'upload.post-transform.error',
} as const

export interface Webhook {
  id: string // WebhookId, Hex string of unique mongodbObjectId
  createdAt: string // ISO8601 date string
  endpoint: string
  secret: string
  enabled: boolean
  suspended: boolean
  events: typeof webhookEvents[keyof typeof webhookEvents][]
}

export interface WebhooksGetResponse {
  webhooks: Webhook[]
  maxWebhooksPerClient: number
}

export default WebhooksGetResponse
